import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import Loader from '../../components/Loader'
// import { useCustomer } from '../../hooks'
import { ROUTES } from '../../shared/constants'
import CustomViewForm from '../../components/CustomViewForm'
import { useCustomer } from '../../hooks/Features/useCustomer'

export default function ViewCustomer() {
  const { customer, loading, getCustomer } = useCustomer()
  const params = useParams()
  const [data, setData] = useState([])

  useEffect(() => {
    getCustomer({ customerId: params.customerId })
  }, [params.customerId])

  useEffect(() => {
    if (customer) {
      setData([
        { label: 'Name', data: customer.name },
        { label: 'Type', data: customer.customerType && customer.customerType.name },
        { label: 'Designation', data: customer.designation },
        { label: 'Phone Number', data: customer.phoneNumber },
        { label: 'Email', data: customer.email },
        { label: 'GST', data: customer.gstNumber },
        { label: 'State', data: customer.state },
        { label: 'City', data: customer.city },
        { label: 'Resident Address', data: customer.address },
        { label: 'Site Address', data: customer.siteAddress },
        { label: 'Assigned Employee', data: customer.addedBy && customer.addedBy.firstName },
        // { label: 'Customer Code', data: customer.customerCode },
        // { label: 'Products', data: customer.products, type: 'Array', field: 'productName' },
        // { label: 'Stores', data: customer.store, type: 'Array', field: 'name' },
      ])
    }
  }, [customer])

  return (
    <Layout heading="Customer" heading2="Info" url1={ROUTES.CUSTOMERS} none>
      {!loading ? (
        <HeaderTabLayout
          heading="Customer"
          content={<CustomViewForm data={data} />}
          view
          url={`/edit-customer/${params.customerId}`}
        />
      ) : (
        <Loader />
      )}
    </Layout>
  )
}
